// Omnix/common/schemas/collections/omniConversations.js
import { z } from "zod";

const ReadStateSchema = z.object({
    userId: z.string().describe("The user ID who has read the conversation."),
    lastReadTimestamp: z.coerce.date().describe("The timestamp of the last interaction they read."),
});

const OmniConversationSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this conversation belongs to."),

    contactId: z.string().describe("Foreign key to the omniContacts collection."),

    channelType: z.enum(["voice", "sms", "whatsapp", "email", "web_chat", "facebook_messenger", "instagram", "telegram"])
        .describe("The specific channel this conversation thread belongs to."),
    channelIdentifier: z.string().describe("The unique identifier for this channel thread (e.g., phone number, email address, session ID)."),

    associatedTicketIds: z.array(z.string()).default([]).describe("An array of _ids from the omniTickets collection linked to this conversation."),
    

    status: z.enum(["open", "pending", "closed"]).default("open").describe("The current state of the conversation."),
    assigneeId: z.string().optional().nullable().describe("The userId of the agent assigned to this conversation."),
    controlledBy: z.enum(['human', 'workflow']).default('human').describe("Indicates if the conversation is actively managed by a human or a workflow."),
    handoffState: z.enum(['none', 'ringing', 'accepted', 'rejected']).default('none').describe("The state of a handoff request from a workflow to a human."),
    lastInteractionTimestamp: z.coerce.date().describe("Timestamp of the last interaction for sorting."),
    lastInteractionSnippet: z.string().optional().nullable().describe("A short preview of the last interaction."),

    readState: z.array(ReadStateSchema).default([]).describe("Tracks which users have read up to what point."),

    tags: z.array(z.string()).optional().default([]),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default OmniConversationSchema;